import { render, staticRenderFns } from "./EditBusinessDatabus.vue?vue&type=template&id=20ae5ac6&scoped=true"
import script from "./EditBusinessDatabus.vue?vue&type=script&lang=js"
export * from "./EditBusinessDatabus.vue?vue&type=script&lang=js"
import style0 from "./EditBusinessDatabus.vue?vue&type=style&index=0&id=20ae5ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae5ac6",
  null
  
)

export default component.exports